module.exports = __webpack_public_path__ + "static/media/rebirth_28.ee4e8694.jpg";